var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseSlider',{attrs:{"value":_vm.value,"labels":_vm.question.answers,"states":_vm.states},on:{"input":_vm.answer}})}
var staticRenderFns = []

export { render, staticRenderFns }